import React, { useEffect, useRef, useState } from 'react';
import '../../styles/DisasterNavBar.css';
import ChatIcon from '../../assets/logos/ChatIcon.svg';
import AgentApps from '../../assets/logos/AgentApps.svg';
import Analytics from '../../assets/logos/Analytics.svg';
import Connectors from '../../assets/logos/Connectors.svg';
import Monitor from '../../assets/logos/Monitor.svg';
import accountCircle from '../../assets/logos/accountCircle.svg';
import Logout from '../../assets/logos/Logout.svg';
import { useNavigate } from 'react-router-dom';
import logger from '../../utils/logger';
import { logout } from '../../resources/api.resource';
import { agenticMsalInstance } from '../../config/agenticMsalConfig';

const NavBar = ({ logedInUserMail }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const logedInUserName = logedInUserMail
    && logedInUserMail
      .split('@')[0]
      .replace(/\d+/g, '')
      .replace(/\./g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = async () => {
    logger.event('Logout called');
    try {
      await agenticMsalInstance.clearCache();
    } catch (_) {
      // Non-fatal
    }
    try {
      const response = await logout();
      if (response?.logoutUrl) {
        window.location.href = response.logoutUrl;
      }
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="navBarContainer">
      <div className="topNav">
        <div className="chatIcons" />
        <div className="iconContainer">
         <img
            src={ChatIcon}
            alt="LLMChatIcon"
            onClick={() => navigate("/chat")}
            className="cursorPointer"
          />
          {/* <div className="tooltip">
            <span className="tooltiptext">Ask LLM Chat</span>
          </div> */}
          <div className="moreAppsContainer">
            <img
              src={AgentApps}
              alt="AgentApps"
              className="cursorPointer"
            />
            {/* <p className="moreApps">Agents & Apps</p> */}
          </div>
          <div className="moreAppsContainer">
            <img src={Analytics} alt="Analytics" className="Analytics" />
          </div>
          <div className="moreAppsContainer">
            <img src={Connectors} alt="Connectors" className="Connectors" />
          </div>
          <div className="moreAppsContainer">
            <img src={Monitor} alt="Monitor" className="Monitor" />
          </div>
        </div>
      </div>
      <div
        className="helpContainer"
        onClick={() => setIsDropdownVisible((prev) => !prev)}
        ref={dropdownRef}
      >
        <div className="helpSection">
          <img
            src={accountCircle}
            alt="accountCircle"
            className="accountCircle"
          />
          {/* <span className='helpHeading'>Help</span> */}
          {isDropdownVisible && (
            <div className="dropdown-content">
              <div className="user-info-dropdown">
                <div className="wrap-user-info">
                  <p className="user-name-dropdown">{logedInUserName}</p>
                  <p className="user-email-dropdown">{logedInUserMail}</p>
                </div>
              </div>

              <div className="logout-version">
                <div className="logoutContainer">
                  <img
                    src={Logout}
                    alt="preload"
                    className="logoutButton"
                    onClick={handleLogout}
                  />
                  <span className="logoutTitle" onClick={handleLogout}>Log out</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default NavBar;
